<template>
    <a-modal title="修改信息" :visible="show" okText="提交" cancelText="返回" @ok="submit" :maskClosable="false" centered @cancel="$emit('close', null)">
        <a-form-model layout="horizontal" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }" :model="formModel">
            <a-form-model-item label="用户名">
                <a-input v-model="formModel.username" placeholder="请输入用户名" />
            </a-form-model-item>
            <a-form-model-item label="密码">
                <a-input v-model="formModel.password" placeholder="请输入密码" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
export default {
    data() {
        return {
            formModel: {
                username: '',
                password: ''
            }
        }
    },
    created() {

    },
    props: {
        show: {
            default: false
        }
    },
    watch: {

    },
    methods: {
        submit() {

        }
    }
}
</script>

<style scoped lang="less">

</style>
